import { UserProgressStatus } from '~/api/learning';

type Translate = (key: string) => string;

export const getModuleCtaLabel = (
  t: Translate,
  status: UserProgressStatus | undefined,
  canRetake: boolean | undefined,
): string => {
  if (
    status === UserProgressStatus.COMPLETED ||
    status === UserProgressStatus.PASSED
  ) {
    return t('learning.view-results');
  }
  if (status === UserProgressStatus.AWAITING_REVIEW) {
    return t('learning.view');
  }
  if (status === UserProgressStatus.IN_PROGRESS) {
    return t('learning.continue');
  }
  if (status === UserProgressStatus.NOT_PASSED) {
    return canRetake
      ? t('learning.retakeAssessment')
      : t('learning.view-results');
  }
  return t('learning.start');
};
